module.exports = "<div *ngIf=\"fms\" class=\"field-manuals\">\n  <div class=\"row\">\n    <ul class=\"col-md-12 tile-list\" [dragula]=\"'bag-one'\" [dragulaModel]=\"fms\">\n        <li class=\"field-manual\" *ngFor=\"let fm of fms; let i = index\">\n          <app-tile [info]=\"fm\" [fmOrder]=\"i\" [tileType]=\"'fm'\"></app-tile>\n        </li>\n    </ul>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/field-manuals/field-manuals.component.html
// module id = ../../../../../src/app/dashboard/program-list/program/field-manuals/field-manuals.component.html
// module chunks = 2